module.exports = __webpack_public_path__ + "media/images/tip_checkbox-5261521aa637f8b6e2a594701a040335.png";